export default __webpack_public_path__ + "static/media/image7.62de533e.jpg";